import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface EmptyReviewsCTAProps {
  link: string;
  locationDisplayName?: string;
  header?: string | null;
}

export default function EmptyReviewsCTA({
  link,
  locationDisplayName,
  header,
}: EmptyReviewsCTAProps): JSX.Element {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {locationDisplayName ? (
        <h2 className={classes.sectionHeader}>
          {locationDisplayName} {t('seoSrp.dealerReviews.header')}
        </h2>
      ) : null}
      {header ? <div className={classes.sectionHeader}>{header}</div> : null}
      <div className={classes.noReviewsContainer}>
        <div className={classes.noReviewsHeader}>{t('seoSrp.dealerReviews.noReviews.header')}</div>
        <div className={classes.buttonContainer}>
          <Button className={classes.writeReviewButton} href={link} target="_blank" disableRipple>
            {t('seoSrp.dealerReviews.noReviews.button')}
          </Button>
        </div>
      </div>
    </>
  );
}
